/**
 * Ícono de temporada sobre el logo (ADR 259 de CardVault).
 *
 * Consume cards.the-vault.mx/api/temporada: el calendario vive allá una sola
 * vez para que la app y la tienda muestren lo mismo, y la fecha se calcula en
 * hora de CDMX y no en la página cacheada de Shopify. Si no hay temporada (lo
 * normal) o el endpoint falla, no se pinta nada.
 *
 * Va montado un poquito sobre el cuadro blanco del logo, como algo que el logo
 * trae puesto. La posición se mide contra la imagen y no contra el contenedor:
 * en móvil el logo va centrado y el contenedor ocupa todo el ancho.
 *
 * Vive dentro del link del logo (como el badge PRO/STR), así que el clic se
 * detiene aquí: tocarlo abre la frase, no el home. En escritorio la frase sale
 * con hover o con el teclado; en móvil con el tap, y se cierra sola a los 4 s o
 * al tocar en otro lado.
 *
 * `?sin-temporada` lo apaga (para grabar material que no se feche) y
 * `?temporada=YYYY-MM-DD` muestra el de ese día. Con `shopify theme dev`,
 * `?temporada-api=http://localhost:3259` apunta a un CardVault local.
 *
 * Construye nodos DOM (nada de innerHTML con datos remotos).
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://cards.the-vault.mx/api/temporada';
  // Sobre el cuadro blanco, cargado a la izquierda de su punta, en fracción
  // de la imagen.
  var CENTRO_X = 0.08;
  var CENTRO_Y = 0.06;
  var LADO = 30;

  var SVG_NS = 'http://www.w3.org/2000/svg';

  function svg(hijos) {
    var root = document.createElementNS(SVG_NS, 'svg');
    root.setAttribute('viewBox', '0 0 24 24');
    root.setAttribute('aria-hidden', 'true');
    root.setAttribute('class', 'vault-temporada__svg');
    hijos.forEach(function (h) {
      var node = document.createElementNS(SVG_NS, h[0]);
      Object.keys(h[1]).forEach(function (k) { node.setAttribute(k, h[1][k]); });
      root.appendChild(node);
    });
    return root;
  }

  // Mismo dibujo que components/vaultComponents/icono-de-temporada.tsx.
  function pokebola() {
    return svg([
      ['circle', { cx: 12, cy: 12, r: 10.5, fill: '#fff', stroke: '#111', 'stroke-width': 1.5 }],
      ['path', { d: 'M1.5 12a10.5 10.5 0 0 1 21 0z', fill: '#e24b4a', stroke: '#111', 'stroke-width': 1.5 }],
      ['line', { x1: 1.5, y1: 12, x2: 22.5, y2: 12, stroke: '#111', 'stroke-width': 2 }],
      ['circle', { cx: 12, cy: 12, r: 3.4, fill: '#fff', stroke: '#111', 'stroke-width': 1.8 }],
    ]);
  }

  function mana() {
    return svg([
      ['circle', { cx: 12, cy: 4.5, r: 3.4, fill: '#f8f6d8', stroke: '#111', 'stroke-width': 0.6 }],
      ['circle', { cx: 19.5, cy: 10, r: 3.4, fill: '#378add' }],
      ['circle', { cx: 16.6, cy: 19, r: 3.4, fill: '#888780', stroke: '#2c2c2a' }],
      ['circle', { cx: 7.4, cy: 19, r: 3.4, fill: '#e24b4a' }],
      ['circle', { cx: 4.5, cy: 10, r: 3.4, fill: '#639922' }],
    ]);
  }

  function visual(icono) {
    if (icono.tipo === 'pokebola') return pokebola();
    if (icono.tipo === 'mana') return mana();
    var span = document.createElement('span');
    span.setAttribute('aria-hidden', 'true');
    // Windows no dibuja banderas: muestra "MX" en letras.
    var windows = navigator.userAgent.indexOf('Windows') !== -1;
    span.textContent = String(windows && icono.alterno ? icono.alterno : icono.valor || '');
    return span;
  }

  function montar(wrapper, img, temporada) {
    var boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'vault-temporada';
    boton.setAttribute('aria-label', String(temporada.nombre || ''));
    boton.appendChild(visual(temporada.icono || {}));

    var frase = document.createElement('span');
    frase.className = 'vault-temporada__frase';
    frase.id = 'vault-frase-de-temporada';
    frase.setAttribute('role', 'tooltip');
    frase.textContent = String(temporada.frase || '');

    wrapper.appendChild(boton);
    wrapper.appendChild(frase);

    function colocar() {
      var w = wrapper.getBoundingClientRect();
      var i = img.getBoundingClientRect();
      var izq = i.left - w.left + i.width * CENTRO_X - LADO / 2;
      var arriba = i.top - w.top + i.height * CENTRO_Y - LADO / 2;
      boton.style.left = izq + 'px';
      boton.style.top = arriba + 'px';
      frase.style.top = arriba + LADO + 4 + 'px';
      // La frase crece hacia la derecha, sin salirse de la pantalla.
      var maxIzq = window.innerWidth - 12 - frase.offsetWidth - w.left;
      frase.style.left = Math.max(-w.left + 12, Math.min(izq - 8, maxIzq)) + 'px';
    }

    colocar();
    window.addEventListener('resize', colocar);
    // El header "reduce-logo-size" encoge el logo al hacer scroll.
    if (window.ResizeObserver) new ResizeObserver(colocar).observe(img);

    var cierre;
    var punteroEsMouse = false;

    function abrir(si) {
      frase.classList.toggle('is-open', si);
      if (si) boton.setAttribute('aria-describedby', frase.id);
      else boton.removeAttribute('aria-describedby');
    }

    boton.addEventListener('pointerdown', function (e) { punteroEsMouse = e.pointerType === 'mouse'; });
    boton.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') abrir(true); });
    boton.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') abrir(false); });
    // Solo el foco de teclado: en Android el tap también enfoca, y abrir aquí
    // para que el clic la cierre dejaría la frase sin verse.
    boton.addEventListener('focus', function () { if (boton.matches(':focus-visible')) abrir(true); });
    boton.addEventListener('blur', function () { abrir(false); });
    boton.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      // Con mouse la abre el hover; el clic no debe cerrarla debajo del cursor.
      if (punteroEsMouse) return;
      clearTimeout(cierre);
      var abierta = !frase.classList.contains('is-open');
      abrir(abierta);
      if (abierta) cierre = setTimeout(function () { abrir(false); }, 4000);
    });
    document.addEventListener('pointerdown', function (e) {
      if (e.target !== boton && !boton.contains(e.target)) abrir(false);
    });
  }

  function init() {
    var params = new URLSearchParams(window.location.search);
    if (params.has('sin-temporada')) return;

    var wrapper = document.querySelector('.header__heading-logo-wrapper');
    var img = wrapper && wrapper.querySelector('img');
    if (!img) return;

    var base = ENDPOINT;
    var local = params.get('temporada-api');
    var esDev = /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
    if (esDev && local && /^http:\/\/localhost:\d+$/.test(local)) base = local + '/api/temporada';

    var fecha = params.get('temporada');
    var url = fecha && /^\d{4}-\d{2}-\d{2}$/.test(fecha) ? base + '?fecha=' + fecha : base;

    fetch(url)
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (json) {
        if (json && json.temporada) montar(wrapper, img, json.temporada);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
